import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CustomerService } from '../../../../account/services/customer.service';
import { CustomerRgpdInterface } from '../../../../account/models/customer-rgpd.interface';
import { SaveCustomerMission } from '../../../store/actions/customer-mission.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';

@Component({
  selector: 'app-customer-rgpd',
  templateUrl: './customer-rgpd.component.html',
  styleUrls: ['./customer-rgpd.component.css'],
  standalone: false
})
export class CustomerRgpdComponent implements OnInit {

  @Input()
  procedureCode: string;
  customerRgpdInterface: CustomerRgpdInterface;
  sectionOpen: boolean;
  accessDataSectionOpen: boolean;
  correctDataSectionOpen: boolean;
  deleteDataSectionOpen: boolean;
  showPopup: boolean;
  personalDataAccessConfirmed: boolean;

  sections = [
    {
      title: 'Mes données, mon contrôle',
      code: 'my data section',
      open: false
    },
    {
      title: 'Mes préférences de contact',
      code: 'my contact section',
      open: false
    }
  ];

  dataDetails: Array<{
      key: string;
      label: string;
      content: SafeHtml;
      checked: boolean
  }> = [];
  contactDetails: Array<{
      key: string;
      label: string;
      checked: boolean
  }> = [];
  constructor(
      private store: Store<any>,
      private sanitizer: DomSanitizer,
      private customerService: CustomerService,
  ) {
  }

  ngOnInit() {
      this.sectionOpen = false;
      this.accessDataSectionOpen = false;
      this.correctDataSectionOpen = false;
      this.deleteDataSectionOpen = false;
      this.showPopup = false;
      this.personalDataAccessConfirmed = false;
      this.customerService.getCustomerRgpd().subscribe(response => {
      this.customerRgpdInterface = response;
      this.dataDetails = [
        {
          key: 'personalizedOffers',
          label: 'Offres SFR personnalisées, émises par SFR',
          content: this.sanitizer.bypassSecurityTrustHtml(
              `J’accepte de recevoir des offres <strong>SFR ou RED personnalisées</strong> en fonction de l’usage de mes services.
                      <br> Ces offres pourront vous être proposées par différents canaux (email, SMS, réseaux sociaux) selon les choix exprimés dans la 
                      rubrique "Mes préférences de contact". `
          ),
          checked: !!this.customerRgpdInterface.personalizedOffers,
        },
        {
          key: 'staticsUsage',
          label: 'Statistiques connaissance clients',
          content: this.sanitizer.bypassSecurityTrustHtml(
              `J’accepte que mes données, dont mes données d'usage, permettent à SFR de mieux comprendre mes attentes et affiner la connaissance de sa base client en général. `
          ),
          checked: !!this.customerRgpdInterface.staticsUsage
        },
        {
          key: 'thirdPartyOffers',
          label: 'Offres de tiers personnalisées, émises par SFR ou ses partenaires',
          content: this.sanitizer.bypassSecurityTrustHtml(
              `J’accepte de recevoir des offres ou communications <a target="_blank" href="https://www.sfrbusiness.fr/partenaires-technologiques/" style="text-decoration: underline !important; text-decoration-color: #007bff !important; background-color: transparent !important;">de SFR et de ses partenaires</a>.`
          ),
          checked: !!this.customerRgpdInterface.thirdPartyOffers
        }
       ];
      this.contactDetails = [
        {
          key: 'smsContact',
          label: 'Email',
          checked: !!this.customerRgpdInterface.emailContact
        },
        {
          key: 'emailContact',
          label: 'SMS',
          checked: !!this.customerRgpdInterface.smsContact
        },
        {
          key: 'phoneContact',
          label: 'Téléphone',
          checked: !!this.customerRgpdInterface.phoneContact
        },
        {
          key: 'postContact',
          label: 'Courrier',
          checked: !!this.customerRgpdInterface.postContact
        },
        {
          key: 'contactedForSurveys',
          label: 'Etre contacté pour des enquetes pour le compte de SFR',
          checked: !!this.customerRgpdInterface.contactedForSurveys
        },
      ]
    });
  }

  save() {
      this.store.dispatch(new SaveCustomerMission(this.buildUpdatedCustomerRgpd(), ConstsHelper.PROCEDURE_CUSTOMER_RGPD, 'account'));
  }

  buildUpdatedCustomerRgpd(): CustomerRgpdInterface {
      const result: any = {};

      this.dataDetails.forEach(item => {
          result[item.key] = !!item.checked;
      });

      this.contactDetails.forEach(item => {
          result[item.key] = !!item.checked;
      });

      result.personalDataAccess = this.customerRgpdInterface.personalDataAccess;
      result.deleted = this.customerRgpdInterface.deleted;
      return result as CustomerRgpdInterface;
  }

    onPersonalDataAccessCheckboxChange(event){
        if (event.target.checked) {
            this.showPopup = true;
            this.customerRgpdInterface.personalDataAccess = false;
        } else {
            this.personalDataAccessConfirmed = false;
            this.customerRgpdInterface.personalDataAccess = false;
        }
    }

    confirmPopup() {
        this.customerRgpdInterface.personalDataAccess = true;
        this.personalDataAccessConfirmed = true;
        this.showPopup = false;
    }

    cancelPopup(): void {
        this.customerRgpdInterface.personalDataAccess = this.personalDataAccessConfirmed;
        this.personalDataAccessConfirmed = false;
        this.showPopup = false;
    }

  toggle(section: any) {
    section.open = !section.open;
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }
}
